// Core lifecycle statuses
export const ACTIVE = 'Active'
export const TEST = 'Test'
export const OBSOLETE = 'Obsolete'
export const ERROR = 'Error'
export const NEW = 'New'
export const RETURNED = 'Returned'
export const DESIGN = 'Design'

// Legacy status - deprecated, will be removed in future release
// @deprecated Use TEST -> ACTIVE flow instead (PBI 133848)
export const VERIFIED = 'Verified'
export const PENDING = 'Pending Verification'

// Display labels for C+ aligned lifecycle model (PBI 133848)
export const DISPLAY_STATUS = Object.freeze({
  [NEW]: 'Design (New)',
  [RETURNED]: 'Design (Returned)',
  [DESIGN]: 'Design',
  [TEST]: 'Test',
  [ACTIVE]: 'Active',
  [OBSOLETE]: 'Obsolete',
  [VERIFIED]: 'Test', // PBI 133848: Verified consolidated into Test
})

// Status groupings
export const EDITABLE_STATUSES = [NEW, RETURNED, DESIGN]
export const DESIGN_STATUSES = [NEW, RETURNED, DESIGN]
export const NON_EDITABLE_STATUSES = [ACTIVE, TEST, VERIFIED, OBSOLETE]
export const VALID_STATUSES = [ACTIVE, TEST, VERIFIED]

// C+ aligned valid statuses (without VERIFIED)
export const VALID_STATUSES_C_PLUS = [ACTIVE, TEST]
